(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    

/*
    A simple jQuery modal (http://github.com/kylefox/jquery-modal)
    Version 0.9.1
*/
!function(o){"object"==typeof module&&"object"==typeof module.exports?o(require("jquery"),window,document):o(jQuery,window,document)}(function(o,t,i,e){var s=[],l=function(){return s.length?s[s.length-1]:null},n=function(){var o,t=!1;for(o=s.length-1;o>=0;o--)s[o].$blocker&&(s[o].$blocker.toggleClass("current",!t).toggleClass("behind",t),t=!0)};o.modal=function(t,i){var e,n;if(this.$body=o("body"),this.options=o.extend({},o.modal.defaults,i),this.options.doFade=!isNaN(parseInt(this.options.fadeDuration,10)),this.$blocker=null,this.options.closeExisting)for(;o.modal.isActive();)o.modal.close();if(s.push(this),t.is("a"))if(n=t.attr("href"),this.anchor=t,/^#/.test(n)){if(this.$elm=o(n),1!==this.$elm.length)return null;this.$body.append(this.$elm),this.open()}else this.$elm=o("<div>"),this.$body.append(this.$elm),e=function(o,t){t.elm.remove()},this.showSpinner(),t.trigger(o.modal.AJAX_SEND),o.get(n).done(function(i){if(o.modal.isActive()){t.trigger(o.modal.AJAX_SUCCESS);var s=l();s.$elm.empty().append(i).on(o.modal.CLOSE,e),s.hideSpinner(),s.open(),t.trigger(o.modal.AJAX_COMPLETE)}}).fail(function(){t.trigger(o.modal.AJAX_FAIL);var i=l();i.hideSpinner(),s.pop(),t.trigger(o.modal.AJAX_COMPLETE)});else this.$elm=t,this.anchor=t,this.$body.append(this.$elm),this.open()},o.modal.prototype={constructor:o.modal,open:function(){var t=this;this.block(),this.anchor.blur(),this.options.doFade?setTimeout(function(){t.show()},this.options.fadeDuration*this.options.fadeDelay):this.show(),o(i).off("keydown.modal").on("keydown.modal",function(o){var t=l();27===o.which&&t.options.escapeClose&&t.close()}),this.options.clickClose&&this.$blocker.click(function(t){t.target===this&&o.modal.close()})},close:function(){s.pop(),this.unblock(),this.hide(),o.modal.isActive()||o(i).off("keydown.modal")},block:function(){this.$elm.trigger(o.modal.BEFORE_BLOCK,[this._ctx()]),this.$body.css("overflow","hidden"),this.$blocker=o('<div class="'+this.options.blockerClass+' blocker current"></div>').appendTo(this.$body),n(),this.options.doFade&&this.$blocker.css("opacity",0).animate({opacity:1},this.options.fadeDuration),this.$elm.trigger(o.modal.BLOCK,[this._ctx()])},unblock:function(t){!t&&this.options.doFade?this.$blocker.fadeOut(this.options.fadeDuration,this.unblock.bind(this,!0)):(this.$blocker.children().appendTo(this.$body),this.$blocker.remove(),this.$blocker=null,n(),o.modal.isActive()||this.$body.css("overflow",""))},show:function(){this.$elm.trigger(o.modal.BEFORE_OPEN,[this._ctx()]),this.options.showClose&&(this.closeButton=o('<a href="#close-modal" rel="modal:close" class="close-modal '+this.options.closeClass+'">'+this.options.closeText+"</a>"),this.$elm.append(this.closeButton)),this.$elm.addClass(this.options.modalClass).appendTo(this.$blocker),this.options.doFade?this.$elm.css({opacity:0,display:"inline-block"}).animate({opacity:1},this.options.fadeDuration):this.$elm.css("display","inline-block"),this.$elm.trigger(o.modal.OPEN,[this._ctx()])},hide:function(){this.$elm.trigger(o.modal.BEFORE_CLOSE,[this._ctx()]),this.closeButton&&this.closeButton.remove();var t=this;this.options.doFade?this.$elm.fadeOut(this.options.fadeDuration,function(){t.$elm.trigger(o.modal.AFTER_CLOSE,[t._ctx()])}):this.$elm.hide(0,function(){t.$elm.trigger(o.modal.AFTER_CLOSE,[t._ctx()])}),this.$elm.trigger(o.modal.CLOSE,[this._ctx()])},showSpinner:function(){this.options.showSpinner&&(this.spinner=this.spinner||o('<div class="'+this.options.modalClass+'-spinner"></div>').append(this.options.spinnerHtml),this.$body.append(this.spinner),this.spinner.show())},hideSpinner:function(){this.spinner&&this.spinner.remove()},_ctx:function(){return{elm:this.$elm,$elm:this.$elm,$blocker:this.$blocker,options:this.options}}},o.modal.close=function(t){if(o.modal.isActive()){t&&t.preventDefault();var i=l();return i.close(),i.$elm}},o.modal.isActive=function(){return s.length>0},o.modal.getCurrent=l,o.modal.defaults={closeExisting:!0,escapeClose:!0,clickClose:!0,closeText:"Close",closeClass:"",modalClass:"modal",blockerClass:"jquery-modal",spinnerHtml:'<div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div>',showSpinner:!0,showClose:!0,fadeDuration:null,fadeDelay:1},o.modal.BEFORE_BLOCK="modal:before-block",o.modal.BLOCK="modal:block",o.modal.BEFORE_OPEN="modal:before-open",o.modal.OPEN="modal:open",o.modal.BEFORE_CLOSE="modal:before-close",o.modal.CLOSE="modal:close",o.modal.AFTER_CLOSE="modal:after-close",o.modal.AJAX_SEND="modal:ajax:send",o.modal.AJAX_SUCCESS="modal:ajax:success",o.modal.AJAX_FAIL="modal:ajax:fail",o.modal.AJAX_COMPLETE="modal:ajax:complete",o.fn.modal=function(t){return 1===this.length&&new o.modal(this,t),this},o(i).on("click.modal",'a[rel~="modal:close"]',o.modal.close),o(i).on("click.modal",'a[rel~="modal:open"]',function(t){t.preventDefault(),o(this).modal()})});
  
    var checkNewsletter = function(){
      var date = new Date();
      if(localStorage.getItem('tmx-newsletter') == null || localStorage.getItem('tmx-newsletter') == "undefined" ){
            $("#newsletter-popup").modal({
              fadeDuration: 500
            });
            localStorage.setItem('tmx-newsletter', date );
      }
      else{
        var check_time = new Date(date) - new Date(localStorage.getItem('tmx-newsletter'));
        var ms = check_time % 1000;
        check_time = (check_time - ms) / 1000;
        var days = Math.floor(check_time / 86400);
        if(days > 1){
          $("#newsletter-popup").modal({
              fadeDuration: 500
            });
          localStorage.setItem('tmx-newsletter', date );
        }
      }
    }
    
  $(document).ready(function(){
    if($("#newsletter-popup").length > 0) checkNewsletter();
        
    function getWorldTime(tzOffset) { // 24시간제
      var now = new Date();
      var tz = now.getTime() + (now.getTimezoneOffset() * 60000) + (tzOffset * 3600000);
      now.setTime(tz);
    
    
      var s =
        leadingZeros(now.getFullYear(), 4) + '-' +
        leadingZeros(now.getMonth() + 1, 2) + '-' +
        leadingZeros(now.getDate(), 2) + ' ' +
    
        leadingZeros(now.getHours(), 2) + ':' +
        leadingZeros(now.getMinutes(), 2) + ':' +
        leadingZeros(now.getSeconds(), 2);
    
      return s;
    }
    
    
    function leadingZeros(n, digits) {
      var zero = '';
      n = n.toString();
    
      if (n.length < digits) {
        for (i = 0; i < digits - n.length; i++)
          zero += '0';
      }
      return zero + n;
    }
      
      var now_addr = window.location.href;
      var preview = now_addr.split('?preview=');
    if(getWorldTime(+9) < '2023-10-12 00:00:00' || preview[1] == 'true'){
      $('.promotion_vis').show();
    }else{
      $('.promotion_vis').remove();      
      $('#newsletter-popup').remove();
    }
  });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review_slide"] && !Shopify.designMode) return;
  try {
    
  $('.review-pop .content .close-btn').click(function(){
    if($(this).parents('.review-pop').hasClass('on')){
      $('.review-pop').removeClass('on'); 
      $('body').removeClass('background');
    }
  });

$('.review-pop .content .cont-area .top-flex .cont-box .cart-btn').click(function() { 
  if ($('.review-pop').hasClass('on')) {
    setTimeout(function(){
      $('.product-form__input input[type=radio]:nth-of-type(3)').attr("checked", false);
      $('.product-form__input input[type=radio]:nth-of-type(1)').attr("checked", true)
      $('.product-form__input input[type=radio]:nth-of-type(1) + label').trigger('click');    
      var sec_val =  $('.product-form__input input[type=radio]:nth-of-type(1) + label strong').attr('valId');
      $('.product-variant-id').attr('value', sec_val);
    }, 500);
  }
});


  $('#shopify-section-template--22039134798103__4918a30a-258a-468d-b4e3-17978d1ea977 .review-pop .content .cont-area .top-flex .cont-box .cart-btn').text('Shop Now');

let link = ''; // Declare the link variable in a higher scope

$('.rv_slide .swiper-slide').click(function(){
    const content = $(this).find('.desc .content').html();
    const type = $(this).find('.desc .type').html();
    const name = $(this).find('.desc .name').html();
    const star = $(this).find('.desc .star').html();
    const thumb = $(this).find('.pd_thumb img').attr('src');
    const customer = $(this).find('.desc .writer').html();
    link = $(this).find('.desc .link').html(); // Set the link variable here
    const reviewImgSrc = $(this).find('.thumb img').attr('src');




// 조건문에서 버튼 텍스트 설정
if (window.location.href !== link) {
    $('.review-pop .content .cont-area .top-flex .cont-box .cart-btn').text('Shop Now').on('click', function() {
        if (window.location.href !== link) {
            window.location.href = link; // link로 이동
        }
    });
} else {
    $('.review-pop .content .cont-area .top-flex .cont-box .cart-btn').text('Add to Cart').on('click', function() {
        if (window.location.href === link) {
          setTimeout(function(){
                  $('.product-form__submit').trigger('click');
          }, 500);
        }
    });
}


  
    $('.review-pop').addClass('on');
    $('.review-pop .content .cont-area .top-flex .custom span').html(customer);
    $('.review-pop .content .cont-area .top-flex .pd-name').html(name);
    $('.review-pop .content .cont-area .top-flex .star').html(star);
    $('.review-pop .content .cont-area .top-flex .thumb-box img').attr('src', thumb);
    
    $('.review-pop .content .cont-area .bot-flex .review').html(content);
    $('.review-pop .content .cont-area .bot-flex .type-box').html(type);
    
    $('.review-pop .content .img-area img').attr('src', reviewImgSrc);
    $('body').addClass('background');
});

$('#shopify-section-template--22039134798103__4918a30a-258a-468d-b4e3-17978d1ea977 .review-pop .content .cont-area .top-flex .cont-box .cart-btn').on('click', function() {
    window.location.href = link; // Use the link variable here
});




  } catch(e) { console.error(e); }
})();
})();
